import { ChevronDown } from '@patrianna-icons/material-icons'
import cx from 'classnames'
import { useEffect, useState } from 'react'

import GoldCurrency from 'containers/Layouts/Layout/Header/components/LoggedIn/GoldCurrency'
import SweepstakeCurrency from 'containers/Layouts/Layout/Header/components/LoggedIn/SweepstakeCurrency'
import type { SupportedCurrencies } from 'types/currencies'

import classes from './styles.module.scss'

type Props = {
  activeCurrency: SupportedCurrencies
}

const currencyComponents = {
  GC: <GoldCurrency />,
  SC: <SweepstakeCurrency />,
}

function Amount(props: Props) {
  const [animate, setAnimate] = useState(false)

  useEffect(() => {
    if (!animate) {
      setTimeout(() => {
        setAnimate(true)
      }, 4000)
    }
  }, [animate])

  return (
    <div className={cx(classes.root, animate && classes.animate)}>
      <div className={cx(classes.amount, animate && classes.hide)}>{currencyComponents[props.activeCurrency]}</div>
      <div onClick={() => setAnimate(false)} className={cx(classes.button, animate && classes.showButton)}>
        <ChevronDown className={classes.down} />
      </div>
    </div>
  )
}

export default Amount
